import Vue from 'vue'
import configs from '@/config'
import store from '@/store'
import constants from '@/constant'

let resource = null

const actions = {
  createReaction: {
    method: 'POST',
    url: `${configs.baseUrl}/api/reaction/`,
  },
  createReactionViaLiveApi: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/reactions`,
  },
  createReactionViaLiveProxy: {
    method: 'POST',
    url: `${configs.liveProxyUrl}/api/live/reactions`,
  },
  createReactionViaLiveProxyNewKafka: {
    method: 'POST',
    url: `${configs.liveProxyUrl}/api/${constants.LiveProxyRootPath}/reactions`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createReaction = async (payload) => {
  if (store.getters['featureToggles/turnOffReactionSaveDB']) {
    payload.enableForBigEvent = true
  }
  if (store.getters['liveStatsV2/canSubmitNewLiveProxy']) {
    const res = await resource.createReactionViaLiveProxyNewKafka(payload)
    return res.body
  }
  if (store.getters['liveStatsV2/canUseReactionLiveProxy']) {
    const res = await resource.createReactionViaLiveProxy(payload)
    return res.body
  }
  if (store.getters['liveStatsV2/canSubmitReactionEmqx']) {
    const res = await resource.createReactionViaLiveApi(payload)
    return res.body
  }
  const res = await resource.createReaction(payload)
  return res.body
}

export default {
  initResource,
  createReaction,
}
